import { Dispatch } from 'redux'
import { DashboardPageStoreEntry } from 'redux/reducers/DashboardPage'

import { useThunkActions } from 'redux/actions/useThunkActions'

import * as actions from './actions'

function updateOneDashboardPageEntry(entry: DashboardPageStoreEntry) {
  return (dispatch: Dispatch) => {
    dispatch(actions.updateOne(entry))
  }
}

function updateManyDashboardPageEntires(entries: DashboardPageStoreEntry[]) {
  return (dispatch: Dispatch) => {
    dispatch(actions.updateMany(entries))
  }
}

export const useDashboardPageStateActions = () => {
  return {
    updateOneDashboardPageEntry: useThunkActions(updateOneDashboardPageEntry),
    updateManyDashboardPageEntires: useThunkActions(
      updateManyDashboardPageEntires
    )
  }
}
